import {createGlobalStyle} from 'styled-components';
import {device} from './mixins.js';

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }
  
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .csl-dialog__dialog {
    width: 500px;
    #new-mobile-number-radio-error {
      display: none;
    }
  }

  @media ${device.laptop} {
    .csl-dialog__close-button {
      padding: 0.8rem;
    }
  }
  
  @media ${device.tablet} {
    .csl-dialog__dialog {
      width: 390px;
    }
  }
  @media ${device.mobile} {
    .csl-dialog__dialog {
      width: 350px;
    }
  }
  @media ${device.mobileM} {
    .csl-dialog__dialog {
      width: 320px;
    }
  }
`;

export default GlobalStyle;
